import { Container, ImgOption, TextOption } from "./MCQOptions.styles";
import HTMLReactParser from "html-react-parser";
import convertTagsToHTML from "helpers/convertTagsToHtml";
import MCQCorrectIcon from "assets/img/question/mcqCorrect.svg";
import MCQWrongIcon from "assets/img/question/mcqWrong.svg";

const MCQOptions = ({ data }) => {
  const isQnCorrect = null;
  return (
    <Container hasImgOption={data.hasImgOption} data-cy="mcq-options">
      {data.options.map((option) => {
        // Remove non-breaking space entities
        const filteredHTML = option.content.replace(/&nbsp;/g, " ");
        const isAnswerInputDisabled = false;
        const isSelected = false;
        const isCorrect = null;
        return data.hasImgOption ? (
          <ImgOption
            data-cy={`option-img-${option.refId}`}
            key={option.refId}
            isAnswerInputDisabled={isAnswerInputDisabled}
            isQnCorrect={isQnCorrect}
            isCorrect={isCorrect}
            selected={isSelected}
            onClick={() => {}}
          >
            {HTMLReactParser(convertTagsToHTML(option.content))}
            {(isCorrect === true || isCorrect === false) && (
              <img
                className={`is-correct-icon ${
                  isCorrect
                    ? `correct-icon-${option.refId}`
                    : `wrong-icon-${option.refId}`
                }`}
                src={isCorrect ? MCQCorrectIcon : MCQWrongIcon}
                alt={isCorrect ? "Correct" : "Wrong"}
              />
            )}
          </ImgOption>
        ) : (
          <TextOption
            data-cy={`option-${option.refId}`}
            key={option.refId}
            isAnswerInputDisabled={isAnswerInputDisabled}
            isQnCorrect={isQnCorrect}
            isCorrect={isCorrect}
            selected={isSelected}
            onClick={() => {}}
          >
            <p>{HTMLReactParser(convertTagsToHTML(filteredHTML))}</p>
            {(isCorrect === true || isCorrect === false) && (
              <img
                className={`is-correct-icon ${
                  isCorrect
                    ? `correct-icon-${option.refId}`
                    : `wrong-icon-${option.refId}`
                }`}
                src={isCorrect === true ? MCQCorrectIcon : MCQWrongIcon}
                alt={isCorrect === true ? "Correct" : "Wrong"}
              />
            )}
          </TextOption>
        );
      })}
    </Container>
  );
};

export default MCQOptions;
